export const parseCheckNumber = (referenceNumber: string) => {
    if (referenceNumber.length > 6) {
        return referenceNumber.substring(referenceNumber.length - 6);
    }
    return referenceNumber;
}